import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import classNames from "common/class-names";
import { ReactComponent as LoadingLogo } from "assets/images/loading-logo.svg";

const AppLoadingIndicator = (props) => {
	const [dotCount, setDotCount] = useState(0);

	useEffect(() => {
		const counter = setInterval(() => {
			setDotCount((prev) => (prev >= 3 ? 0 : prev + 1));
		}, 500);

		return () => clearInterval(counter);
	}, []);

	return (
		<div className={classNames({ "app-loading-indicator": true, [props.className]: !!props.className })}>
			<LoadingLogo />
			<p className="app-loading-indicator__text">LOADING</p>
			<p className="app-loading-indicator__dot">
				{[0, 1, 2].map((index) => (
					<span key={index} className={classNames({ "app-loading-indicator__dot-item": true, "app-loading-indicator__dot-item--visible": index < dotCount })}>.</span>
				))}
			</p>
		</div>
	);
};

export default AppLoadingIndicator;

AppLoadingIndicator.propTypes = {
	className: PropTypes.string,
};
